import BuzzerDiagram from "../../../../docs/_images/hw_ff_buzzer.png";
import BuzzerSchematics from "../../../../docs/_images/hw_ff_buzzer_schem.png";
import * as React from 'react';
export default {
  BuzzerDiagram,
  BuzzerSchematics,
  React
};